// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ClientBriefOut } from './clientBriefOut.zod.ts';
import { IdeaRef } from './ideaRef.zod.ts';
import { NamedRef } from './namedRef.zod.ts';
import { NeedsOut } from './needsOut.zod.ts';
import { PersonRef } from './personRef.zod.ts';
import { ResultsOut } from './resultsOut.zod.ts';
import { RunCan } from './runCan.zod.ts';
import { RunFileOut } from './runFileOut.zod.ts';

export const AdvisorRunOut = zod.object({
  "can": RunCan,
  "client": zod.string(),
  "client_brief": zod.union([ClientBriefOut,zod.null()]),
  "client_brief_changed": zod.boolean(),
  "client_brief_confirmed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "client_brief_confirmed_by": zod.union([PersonRef,zod.null()]),
  "client_brief_hash": zod.union([zod.string(),zod.null()]),
  "confirmed_client_brief": zod.union([ClientBriefOut,zod.null()]),
  "cost_usd": zod.string(),
  "country": zod.union([zod.string(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([PersonRef,zod.null()]),
  "crm_reference": zod.union([zod.string(),zod.null()]),
  "error": zod.union([zod.string(),zod.null()]),
  "feedback": zod.union([zod.enum(['useful', 'not_useful']),zod.null()]),
  "feedback_comment": zod.union([zod.string(),zod.null()]),
  "files": zod.array(RunFileOut),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "id": zod.uuid(),
  "idea": zod.union([IdeaRef,zod.null()]),
  "idea_linked": zod.boolean(),
  "industry": zod.union([NamedRef,zod.null()]),
  "needs": zod.union([NeedsOut,zod.null()]),
  "outcome": zod.union([zod.enum(['used_in_proposal', 'shared_with_client', 'won', 'lost']),zod.null()]),
  "problem": zod.string(),
  "results": zod.union([ResultsOut,zod.null()]),
  "status": zod.string()
});

export type AdvisorRunOut = zod.input<typeof AdvisorRunOut>;
export type AdvisorRunOutOutput = zod.output<typeof AdvisorRunOut>;
